import React, { Component } from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import { connect } from "react-redux";
import { searchToObject } from "common/helpers/string";
import { notification } from "components/ui";

import * as action from "../actions/authAction";
import * as selector from "../selectors/authSelector";

import ForgotForm from "../components/ForgotForm";

@connect(
	state => ({
		isLoading: selector.isLoadingSelector(state),
		authForm: selector.authFormSelector(state)
	}),
	{
		sendForgot: action.sendForgot.request
	}
)
export default class ForgotContainer extends Component {
	static propTypes = {
		isLoading: PropTypes.bool,
		sendForgot: PropTypes.func,
		authForm: PropTypes.object,
		history: PropTypes.shape({
			push: PropTypes.func
		}),
		location: PropTypes.shape({
			pathname: PropTypes.string,
			search: PropTypes.string
		})
	};

	constructor(props) {
		super(props);
		this.checkPasswordRestore();
	}

	checkPasswordRestore = () => {
		const { history, location } = this.props;

		const hasRestored_pathname = location.pathname === "/password-restored";
		const hasRestored_success = searchToObject(location.search)?.success;

		if (hasRestored_pathname && hasRestored_success === "true") {
			notification.success("Пароль успешно изменен", "Введите логин и пароль из письма");
			history.push("/sign-in");
		}
	};

	render() {
		const { isLoading, authForm, sendForgot } = this.props;

		return (
			<div className="auth-wrapper">
				<div className="auth-content">
					<div className="auth-bg">
						<span className="r" />
						<span className="r s" />
						<span className="r s" />
						<span className="r" />
					</div>
					<div className="card">
						<div className={cn("card-body text-center")}>
							<ForgotForm initialValues={authForm} isLoading={isLoading} onSubmit={sendForgot} />
						</div>
					</div>
				</div>
			</div>
		);
	}
}
